import React, { useState } from "react";

const services = [
  {
    number: "01",
    icon: "🎓",
    title: "University Admissions",
    desc: "We help you find the right course based on your situation and guide you through the full application process — even if you don't have qualifications.",
    list: [],
  },
  {
    number: "02",
    icon: "📅",
    title: "Flexible Study Options",
    desc: "You can study without stopping work. Options include:",
    list: ["Evenings", "Weekends", "Alongside your job"],
  },
  {
    number: "03",
    icon: "💷",
    title: "Student Finance Support",
    desc: "We guide you through the student finance process step by step. Financial support may be available depending on your situation — and we make sure everything is done correctly and on time.",
    list: [],
  },
  {
    number: "04",
    icon: "✍️",
    title: "Personal Statement & Application Help",
    desc: "Don't worry if you've never written a personal statement before — we'll help you prepare everything properly.",
    list: [],
  },
  {
    number: "05",
    icon: "🎤",
    title: "Interview Preparation",
    desc: "We'll guide you on what to expect and how to present yourself with confidence.",
    list: [],
  },
  {
    number: "06",
    icon: "🤝",
    title: "Ongoing Support",
    desc: "Our support doesn't stop after you enrol. We stay with you throughout your journey to make sure you stay on track and complete your degree.",
    list: [],
  },
];

const Services = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const cardStyle = (index) => ({
    background: "#fff",
    borderRadius: "16px",
    padding: "36px 30px",
    border: `1px solid ${hoveredIndex === index ? "#c2d4f0" : "#e4eaf4"}`,
    position: "relative",
    overflow: "hidden",
    transition:
      "transform 0.35s cubic-bezier(0.23, 1, 0.32, 1), box-shadow 0.35s cubic-bezier(0.23, 1, 0.32, 1), border-color 0.35s ease",
    transform:
      hoveredIndex === index
        ? "translateY(-10px) scale(1.02)"
        : "translateY(0) scale(1)",
    boxShadow:
      hoveredIndex === index
        ? "0 24px 48px rgba(0, 44, 106, 0.13)"
        : "none",
    cursor: "default",
  });

  const iconStyle = (index) => ({
    width: "52px",
    height: "52px",
    borderRadius: "14px",
    background: hoveredIndex === index ? "#002c6a" : "#eef3fb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    fontSize: "22px",
    transition: "background 0.3s ease, transform 0.3s ease",
    transform: hoveredIndex === index ? "scale(1.08)" : "scale(1)",
  });

  return (
    <div
      style={{
        padding: "80px 24px",
        background: "#f4f7fb",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      {/* Header */}
      <div style={{ textAlign: "center", marginBottom: "56px" }}>
        <span
          style={{
            display: "inline-block",
            fontSize: "13px",
            fontWeight: 600,
            letterSpacing: "3px",
            textTransform: "uppercase",
            color: "#002c6a",
            marginBottom: "12px",
          }}
        >
          What We Offer
        </span>
        <h2
          style={{
            fontSize: "clamp(2rem, 4vw, 2.8rem)",
            color: "#0d1b2e",
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          Our Services
        </h2>
      </div>

      {/* Cards Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "24px",
          maxWidth: "1100px",
          margin: "0 auto 40px",
        }}
      >
        {services.map((service, index) => (
          <div
            key={index}
            style={cardStyle(index)}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {/* Top accent bar */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "3px",
                background: "linear-gradient(90deg, #002c6a, #1a5fb4)",
                transform: hoveredIndex === index ? "scaleX(1)" : "scaleX(0)",
                transformOrigin: "left",
                transition: "transform 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
              }}
            />

            {/* Card number */}
            <span
              style={{
                position: "absolute",
                top: "24px",
                right: "24px",
                fontSize: "13px",
                fontWeight: 700,
                color: hoveredIndex === index ? "#a8c0e8" : "#d0dff5",
                letterSpacing: "1px",
                transition: "color 0.3s ease",
              }}
            >
              {service.number}
            </span>

            {/* Icon */}
            <div style={iconStyle(index)}>{service.icon}</div>

            {/* Title */}
            <h3
              style={{
                fontSize: "1.05rem",
                fontWeight: 700,
                color: hoveredIndex === index ? "#002c6a" : "#0d1b2e",
                marginBottom: "10px",
                lineHeight: 1.3,
                transition: "color 0.3s ease",
              }}
            >
              {service.title}
            </h3>

            {/* Description */}
            <p
              style={{
                fontSize: "0.88rem",
                color: "#5a6a82",
                lineHeight: 1.7,
                margin: 0,
              }}
            >
              {service.desc}
            </p>

            {/* Optional list */}
            {service.list.length > 0 && (
              <ul style={{ listStyle: "none", marginTop: "10px", padding: 0 }}>
                {service.list.map((item, i) => (
                  <li
                    key={i}
                    style={{
                      fontSize: "0.88rem",
                      color: "#5a6a82",
                      padding: "3px 0",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: "#002c6a",
                        opacity: 0.5,
                        flexShrink: 0,
                        display: "inline-block",
                      }}
                    />
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {/* Free Banner */}
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          background: "linear-gradient(135deg, #002c6a 0%, #1a5fb4 100%)",
          borderRadius: "20px",
          padding: "44px 48px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "32px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <h3
            style={{
              fontSize: "1.7rem",
              fontWeight: 700,
              color: "#fff",
              marginBottom: "8px",
            }}
          >
            Our Service is 100% Free
          </h3>
          <p
            style={{
              fontSize: "0.95rem",
              color: "rgba(255,255,255,0.75)",
              lineHeight: 1.6,
              maxWidth: "480px",
              margin: 0,
            }}
          >
            We don't charge you anything. Our goal is to make higher education
            accessible — without adding financial pressure.
          </p>
        </div>
        <div
          style={{
            background: "rgba(255,255,255,0.15)",
            border: "2px solid rgba(255,255,255,0.3)",
            borderRadius: "100px",
            padding: "14px 32px",
            color: "#fff",
            fontWeight: 700,
            fontSize: "1rem",
            whiteSpace: "nowrap",
            letterSpacing: "0.5px",
          }}
        >
          ✦ No Fees. Ever.
        </div>
      </div>
    </div>
  );
};

export default Services;